import React from 'react'

const Main = () => {
  return (
    <div className='main-container'>
        <div className='main-letter-i'>I</div>
        <div className='main-letter-am'>AM</div>
        <div className='main-letter-izam'>IZAM</div>
        <div className='main-letter-am'>MA</div>
        <div className='main-letter-i'>I</div>
    </div>
  )
}

export default Main